export const ADD_SELECTED_ATTACHED_FILE = 'ADD_SELECTED_ATTACHED_FILE'
export const ADD_SELECTED_OBSERVERS_GROUPS = 'ADD_SELECTED_OBSERVERS_GROUPS'
export const ADD_SELECTED_OBSERVERS_MEMBERS = 'ADD_SELECTED_OBSERVERS_MEMBERS'
export const ADD_SELECTED_RESPONSIBLES_GROUPS = 'ADD_SELECTED_RESPONSIBLES_GROUPS'
export const ADD_SELECTED_RESPONSIBLES_MEMBERS = 'ADD_SELECTED_RESPONSIBLES_MEMBERS'
export const ADD_SELECTED_VALIDATORS_GROUPS = 'ADD_SELECTED_VALIDATORS_GROUPS'
export const ADD_SELECTED_VALIDATORS_MEMBERS = 'ADD_SELECTED_VALIDATORS_MEMBERS'
export const REMOVE_DELETE_TASK_COMMENT_PENDING = 'REMOVE_DELETE_TASK_COMMENT_PENDING'
export const REMOVE_FROM_EXPAND_TASK_AFTER_DELETE = 'REMOVE_FROM_EXPAND_TASK_AFTER_DELETE'
export const REMOVE_POST_TASK_COMMENT_PENDING = 'REMOVE_POST_TASK_COMMENT_PENDING'
export const REMOVE_TASK_DETAILS_PENDING = 'REMOVE_TASK_DETAILS_PENDING'
export const REMOVE_SELECTED_ATTACHED_FILE = 'REMOVE_SELECTED_ATTACHED_FILE'
export const REMOVE_SELECTED_OBSERVERS_GROUPS = 'REMOVE_SELECTED_OBSERVERS_GROUPS'
export const REMOVE_SELECTED_OBSERVERS_MEMBERS = 'REMOVE_SELECTED_OBSERVERS_MEMBERS'
export const REMOVE_SELECTED_RESPONSIBLES_GROUPS = 'REMOVE_SELECTED_RESPONSIBLES_GROUPS'
export const REMOVE_SELECTED_RESPONSIBLES_MEMBERS = 'REMOVE_SELECTED_RESPONSIBLES_MEMBERS'
export const REMOVE_SELECTED_VALIDATORS_GROUPS = 'REMOVE_SELECTED_VALIDATORS_GROUPS'
export const REMOVE_SELECTED_VALIDATORS_MEMBERS = 'REMOVE_SELECTED_VALIDATORS_MEMBERS'
export const REMOVE_TASK_COMMENTS_PENDING = 'REMOVE_TASK_COMMENTS_PENDING'
export const REMOVE_PANE_TASK_DETAILS_PENDING = 'REMOVE_PANE_TASK_DETAILS_PENDING'
export const REMOVE_TASK_RIGHTS_PENDING = 'REMOVE_TASK_RIGHTS_PENDING'
export const REMOVE_TASK_FOLDER_PENDING = 'REMOVE_TASK_FOLDER_PENDING'
export const RESET_ATTACHED_FILE_VERSIONS = 'RESET_ATTACHED_FILE_VERSIONS'
export const RESET_CHECKLIST = 'RESET_CHECKLIST'
export const RESET_ROLE_PICKER = 'RESET_ROLE_PICKER'
export const RESET_SELECTED_ATTACHED_FILE = 'RESET_SELECTED_ATTACHED_FILE'
export const RESET_TASK_FOLDER = 'RESET_TASK_FOLDER'
export const SET_ATTACHED_FILE_VERSIONS = 'SET_ATTACHED_FILE_VERSIONS'
export const SET_ATTACHED_FILE_VERSIONS_ERROR = 'SET_ATTACHED_FILE_VERSIONS_ERROR'
export const SET_ATTACHED_FILE_VERSIONS_PENDING = 'SET_ATTACHED_FILE_VERSIONS_PENDING'
export const SET_CHECKLIST_STRUCTURE = 'SET_CHECKLIST_STRUCTURE'
export const SET_CHECKLIST_PENDING = 'SET_CHECKLIST_PENDING'
export const SET_CHECKLIST_SECTIONS_DETAILS = 'SET_CHECKLIST_SECTIONS_DETAILS'
export const SET_CHECKLIST_TASKS_DETAILS = 'SET_CHECKLIST_TASKS_DETAILS'
export const REMOVE_CHECKLIST_SECTIONS_DETAILS = 'REMOVE_CHECKLIST_SECTIONS_DETAILS'
export const REMOVE_CHECKLIST_TASKS_DETAILS = 'REMOVE_CHECKLIST_TASKS_DETAILS'
export const SET_CHECKLIST_DETAILS_PENDING = 'SET_CHECKLIST_DETAILS_PENDING'
export const SET_CHECKLIST_LAST_UPDATE_DATE = 'SET_CHECKLIST_LAST_UPDATE_DATE'
export const SET_CHECKLIST_TABLE_HEADER = 'SET_CHECKLIST_TABLE_HEADER'
export const SET_CONTACT_RESPONSIBLE_ERROR = 'SET_CONTACT_RESPONSIBLE_ERROR'
export const SET_CONTACT_RESPONSIBLE_PENDING = 'SET_CONTACT_RESPONSIBLE_PENDING'
export const SET_CREATE_TASK_ERROR = 'SET_CREATE_TASK_ERROR'
export const SET_CREATE_TASK_PENDING = 'SET_CREATE_TASK_PENDING'
export const SET_CREATE_SECTION_PENDING = 'SET_CREATE_SECTION_PENDING'
export const SET_DELETE_FILDERS_ERROR = 'SET_DELETE_FILDERS_ERROR'
export const SET_DELETE_FILDERS_PENDING = 'SET_DELETE_FILDERS_PENDING'
export const SET_DELETE_SAVED_CHECKLIST_PENDING = 'SET_DELETE_SAVED_CHECKLIST_PENDING'
export const SET_DELETE_SAVED_CHECKLIST_ERROR = 'SET_DELETE_SAVED_CHECKLIST_ERROR'
export const SET_SHARE_SAVED_CHECKLIST_PENDING = 'SET_SHARE_SAVED_CHECKLIST_PENDING'
export const SET_SHARE_SAVED_CHECKLIST_ERROR = 'SET_SHARE_SAVED_CHECKLIST_ERROR'
export const SET_RENAME_SAVED_CHECKLIST_PENDING = 'SET_RENAME_SAVED_CHECKLIST_PENDING'
export const SET_RENAME_SAVED_CHECKLIST_ERROR = 'SET_RENAME_SAVED_CHECKLIST_ERROR'
export const SET_DELETE_TABLE_SELECTION_ERROR = 'SET_DELETE_TABLE_SELECTION_ERROR'
export const SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING = 'SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING'
export const SET_DELETE_TABLE_SELECTION_PENDING = 'SET_DELETE_TABLE_SELECTION_PENDING'
export const SET_DELETE_TASK_COMMENT_ERROR = 'SET_DELETE_TASK_COMMENT_ERROR'
export const SET_DELETE_TASK_COMMENT_PENDING = 'SET_DELETE_TASK_COMMENT_PENDING'
export const SET_DELETE_TASK_ERROR = 'SET_DELETE_TASK_ERROR'
export const SET_DELETE_TASK_MODAL = 'SET_DELETE_TASK_MODAL'
export const SET_DELETE_TASK_PENDING = 'SET_DELETE_TASK_PENDING'
export const SET_DELETE_SECTION_PENDING = 'SET_DELETE_SECTION_PENDING'
export const SET_DUPLICATE_TASK_ERROR = 'SET_DUPLICATE_TASK_ERROR'
export const SET_DUPLICATE_TASK_PENDING = 'SET_DUPLICATE_TASK_PENDING'
export const SET_EDIT_TASK = 'SET_EDIT_TASK'
export const SET_EDIT_TASK_PENDING = 'SET_EDIT_TASK_PENDING'
export const SET_EDIT_SECTION = 'SET_EDIT_SECTION'
export const SET_EDIT_SECTION_PENDING = 'SET_EDIT_SECTION_PENDING'
export const SET_SECTIONS_EXPAND_STATE = 'SET_SECTIONS_EXPAND_STATE'
export const SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN = 'SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN'
export const SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN = 'SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN'
export const SET_CHECKLISTS_TEMPLATES_SELECTED_TAB = 'SET_CHECKLISTS_TEMPLATES_SELECTED_TAB'
export const SET_IMPORT_CHECKLIST_FROM_CLOSD_ERROR = 'SET_IMPORT_CHECKLIST_FROM_CLOSD_ERROR'
export const SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING = 'SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING'
export const SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING = 'SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING'
export const SET_LAST_ITEM_ADDED = 'SET_LAST_ITEM_ADDED'
export const SET_MOVE_FILDERS_ERROR = 'SET_MOVE_FILDERS_ERROR'
export const SET_MOVE_FILDERS_PENDING = 'SET_MOVE_FILDERS_PENDING'
export const SET_CHECKLIST_SHARE_BY_EMAIL_PANE = 'SET_CHECKLIST_SHARE_BY_EMAIL_PANE'
export const SET_CHECKLIST_SHARE_BY_EMAIL_PANE_TAB = 'SET_CHECKLIST_SHARE_BY_EMAIL_PANE_TAB'
export const SET_PARENT_CHILDREN = 'SET_PARENT_CHILDREN'
export const SET_POST_ATTACHED_FILE_VERSIONS_ERROR = 'SET_POST_ATTACHED_FILE_VERSIONS_ERROR'
export const SET_POST_ATTACHED_FILE_VERSIONS_PENDING = 'SET_POST_ATTACHED_FILE_VERSIONS_PENDING'
export const SET_MOVE_ITEMS_PENDING = 'SET_MOVE_ITEMS_PENDING'
export const SET_POST_STATUS_ERROR = 'SET_POST_STATUS_ERROR'
export const SET_POST_STATUS_PENDING = 'SET_POST_STATUS_PENDING'
export const SET_POST_TASK_COMMENT_ERROR = 'SET_POST_TASK_COMMENT_ERROR'
export const SET_POST_TASK_COMMENT_PENDING = 'SET_POST_TASK_COMMENT_PENDING'
export const SET_TASK_DETAILS = 'SET_TASK_DETAILS'
export const SET_TASK_DETAILS_PENDING = 'SET_TASK_DETAILS_PENDING'
export const SET_RENAME_ATTACHED_FILE_DIALOG = 'SET_RENAME_ATTACHED_FILE_DIALOG'
export const SET_RENAME_ATTACHED_FILE_ERROR = 'SET_RENAME_ATTACHED_FILE_ERROR'
export const SET_RENAME_ATTACHED_FILE_PENDING = 'SET_RENAME_ATTACHED_FILE_PENDING'
export const SET_SAVED_CHECKLISTS = 'SET_SAVED_CHECKLISTS'
export const SET_SAVED_CHECKLISTS_ERROR = 'SET_SAVED_CHECKLISTS_ERROR'
export const SET_SAVED_CHECKLISTS_PENDING = 'SET_SAVED_CHECKLISTS_PENDING'
export const SET_SELF_SAVED_CHECKLISTS_PENDING = 'SET_SELF_SAVED_CHECKLISTS_PENDING'
export const SET_SELF_SAVED_CHECKLISTS = 'SET_SELF_SAVED_CHECKLISTS'
export const SET_SELECTED_SELF_SAVED_CHECKLIST = 'SET_SELECTED_SELF_SAVED_CHECKLIST'
export const SET_SELECTED_SAVED_CHECKLIST = 'SET_SELECTED_SAVED_CHECKLIST'
export const SET_SAVED_CHECKLIST_PREVIEW_PENDING = 'SET_SAVED_CHECKLIST_PREVIEW_PENDING'
export const SET_SAVED_CHECKLIST_PREVIEW = 'SET_SAVED_CHECKLIST_PREVIEW'
export const SET_SAVED_CHECKLIST_PREVIEW_ERROR = 'SET_SAVED_CHECKLIST_PREVIEW_ERROR'
export const SET_LEXISNEXIS_CHECKLISTS_PENDING = 'SET_LEXISNEXIS_CHECKLISTS_PENDING'
export const SET_LEXISNEXIS_CHECKLISTS = 'SET_LEXISNEXIS_CHECKLISTS'
export const SET_LEXISNEXIS_CHECKLISTS_ERROR = 'SET_LEXISNEXIS_CHECKLISTS_ERROR'
export const SET_SELECTED_LEXISNEXIS_CHECKLIST = 'SET_SELECTED_LEXISNEXIS_CHECKLIST'
export const SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING = 'SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING'
export const SET_LEXISNEXIS_CHECKLIST_PREVIEW = 'SET_LEXISNEXIS_CHECKLIST_PREVIEW'
export const SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR = 'SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR'
export const SET_SAVE_CHECKLIST_DIALOG_IS_OPEN = 'SET_SAVE_CHECKLIST_DIALOG_IS_OPEN'
export const SET_SAVE_CHECKLIST_ERROR = 'SET_SAVE_CHECKLIST_ERROR'
export const SET_SAVE_CHECKLIST_PENDING = 'SET_SAVE_CHECKLIST_PENDING'
export const SET_UPDATE_CHECKLIST_PENDING = 'SET_UPDATE_CHECKLIST_PENDING'
export const SET_SELECTED_ATTACHED_FILE = 'SET_SELECTED_ATTACHED_FILE'
export const SET_SELECTED_TASKS = 'SET_SELECTED_TASKS'
export const SET_SELECTED_SECTIONS = 'SET_SELECTED_SECTIONS'
export const SET_SHARE_ATTACHED_FILES_ERROR = 'SET_SHARE_ATTACHED_FILES_ERROR'
export const SET_SHARE_ATTACHED_FILES_PENDING = 'SET_SHARE_ATTACHED_FILES_PENDING'
export const SET_SHARE_CHECKLIST_BY_EMAIL_PENDING = 'SET_SHARE_CHECKLIST_BY_EMAIL_PENDING'
export const SET_SHARE_TASKS_DIALOG = 'SET_SHARE_TASKS_DIALOG'
export const SET_SHARE_TASKS_ERROR = 'SET_SHARE_TASKS_ERROR'
export const SET_SHARE_TASKS_PENDING = 'SET_SHARE_TASKS_PENDING'
export const SET_TABLE_TASK_PANE = 'SET_TABLE_TASK_PANE'
export const SET_TABLE_TASK_PANE_TAB = 'SET_TABLE_TASK_PANE_TAB'
export const SET_TASK_COMMENTS_ERROR = 'SET_TASK_COMMENTS_ERROR'
export const SET_TASK_COMMENTS_PENDING = 'SET_TASK_COMMENTS_PENDING'
export const SET_PANE_TASK_DETAILS_PENDING = 'SET_PANE_TASK_DETAILS_PENDING'
export const SET_TASK_RIGHTS_PENDING = 'SET_TASK_RIGHTS_PENDING'
export const SET_TASK_FOLDER = 'SET_TASK_FOLDER'
export const SET_TASK_FOLDER_ERROR = 'SET_TASK_FOLDER_ERROR'
export const SET_TASK_FOLDER_PENDING = 'SET_TASK_FOLDER_PENDING'
export const TOGGLE_SELECTED_OBSERVERS_GROUPS = 'TOGGLE_SELECTED_OBSERVERS_GROUPS'
export const TOGGLE_SELECTED_OBSERVERS_MEMBERS = 'TOGGLE_SELECTED_OBSERVERS_MEMBERS'
export const TOGGLE_SELECTED_RESPONSIBLES_GROUPS = 'TOGGLE_SELECTED_RESPONSIBLES_GROUPS'
export const TOGGLE_SELECTED_RESPONSIBLES_MEMBERS = 'TOGGLE_SELECTED_RESPONSIBLES_MEMBERS'
export const TOGGLE_SELECTED_VALIDATORS_GROUPS = 'TOGGLE_SELECTED_VALIDATORS_GROUPS'
export const TOGGLE_SELECTED_VALIDATORS_MEMBERS = 'TOGGLE_SELECTED_VALIDATORS_MEMBERS'
export const SET_TASK_STATUS_CATEGORIES = 'SET_TASK_STATUS_CATEGORIES'
export const SET_TASK_STATUS_CATEGORIES_PENDING = 'SET_TASK_STATUS_CATEGORIES_PENDING'
export const SET_TASK_STATUS_CATEGORIES_ERROR = 'SET_TASK_STATUS_CATEGORIES_ERROR'
export const REMOVE_CHECKLIST_FILTER = 'REMOVE_CHECKLIST_FILTER'
export const SET_CHECKLIST_FILTERS = 'SET_CHECKLIST_FILTERS'
export const SET_FILTERS_PANE_IS_OPEN = 'SET_FILTERS_PANE_IS_OPEN'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_GLOBAL_TASK_FOLDER_PENDING = 'SET_GLOBAL_TASK_FOLDER_PENDING'
export const SET_GLOBAL_TASK_FOLDER = 'SET_GLOBAL_TASK_FOLDER'
export const SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN = 'SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN'
export const SET_DOWNLOAD_TODO_FILES_PENDING = 'SET_DOWNLOAD_TODO_FILES_PENDING'
export const SET_CHECKLIST_VERSIONING_PANE_TAB = 'SET_CHECKLIST_VERSIONING_PANE_TAB'
export const TOGGLE_CHECKLIST_VERSIONING_PANE = 'TOGGLE_CHECKLIST_VERSIONING_PANE'
export const SET_CHECKLIST_PANE = 'SET_CHECKLIST_PANE'
export const SET_CHECKLIST_PANE_TAB = 'SET_CHECKLIST_PANE_TAB'
export const SET_CHECKLIST_PANE_TASKS = 'SET_CHECKLIST_PANE_TASKS'
export const ADD_CHECKLIST_ITEM_BEING_EDITED = 'ADD_CHECKLIST_ITEM_BEING_EDITED'
export const REMOVE_CHECKLIST_ITEM_BEING_EDITED = 'REMOVE_CHECKLIST_ITEM_BEING_EDITED'
export const SET_CHECKLIST_DRAG_ITEM = 'SET_CHECKLIST_DRAG_ITEM'
export const SET_CHECKLIST_DRAG_OVER_SECTION = 'SET_CHECKLIST_DRAG_OVER_SECTION'
export const SET_CHECKLIST_PRISTINE = 'SET_CHECKLIST_PRISTINE'
export const SET_CHECKLIST_TITLE_INPUT_INVALID = 'SET_CHECKLIST_TITLE_INPUT_INVALID'
export const SET_UPDATE_TASK_STATUSES_PENDING = 'SET_UPDATE_TASK_STATUSES_PENDING'
export const REMOVE_UPDATE_TASK_STATUSES_PENDING = 'REMOVE_UPDATE_TASK_STATUSES_PENDING'
